let currId = 1;

export const nextId = (prefix = '') => {
	return prefix + currId;
};
